import log from "loglevel";
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Breadcrumb } from "react-bootstrap";
import * as constants from "Constants";
import httpService from 'services/httpService.js';
import ProgrammingActivity from "../../../Programming/Instructor/Program/Program.jsx";
import JSZip from "jszip";

function ActivityContainer({ courseId }) {
  const location = useLocation();
  const state = location.state || {};
  const params = useParams();
  const dispatch = useDispatch();

  const [newActivity, setNewActivity] = useState(
    true
  );
  
  const Activity = null;

  // URL path is splitted based on "/" and extracted into array
  // so, later we use the activity Type and activityID that is contained in the URL
  let urlArray = location.pathname;
  if (urlArray[urlArray.length - 1] === "/") {
    //Removing the "/" from last part of URL
    urlArray = urlArray.substring(0, urlArray.length - 1);
  }
  urlArray = urlArray.split("/");

  //State variable common accross all activities
  const [labID, setLabID] = useState(urlArray[urlArray.length - 3]);
  const [activity_title, setActivityTitle] = useState("");
  const [labTitle, setLabTitle] = useState("");
  const [isExam, setIsExam] = useState(false);
  const [examStartTime, setExamStartTime] = useState(null)
  const [duration,setDuration] = useState(null)
  const [studentData, setStudentData] = useState({});
  const [labAvailableTill, setAvailableTill] = useState(
    location.available_till
  );
  const [activity_description, setActivityDescription] = useState("");
  //Setting the Activity ID from the URL if it's "newActivity" setting it to null
  const [activityID, setActivityID] = useState(urlArray[urlArray.length - 1]);
  const [activityType, setActivityType] = useState("templatecode");

  //******************PROGRAMMING ACTIVITY Fields Starts From Here****************/
  //states for main page
  const [ProgrammingActivityDetails, setProgrammingActivityDetails] =
    useState(null);
  const [AccessControlsProgActivity, setAccessControlsProgActivity] =
    useState(null);
  //State to store if the instructor has provided additional files for the programming activity
  const [provideAdditionalFiles, setProvideAdditionalFiles] = useState(false);
  //State to store the additional files provided by the instructor
  const [instructorAdditionalFiles, setInstructorAdditionalFiles] = useState({
    C: [],
    "C++": [],
    Simplecpp: [],
  });

  const [document, setDocument] = useState(null);

  //******************PROGRAMMING ACTIVITY Fields Ends Here****************/

  //******************VIRTUAL ACTIVITY Fields Starts From Here****************/
  //EXPERIMENT DETAILS for Virtual Activity

  //Evaluation Scripts and Docker Configuration for Virtual Activity

  //Add Script Fields for Virtual Activity

  //******************VIRTUAL ACTIVITY Fields Ends Here****************/
  //******************Other ACTIVITY Fields Starts From Here****************/
  const [otherActivityDetails, setOtherActivityDetails] = useState(null);
  //******************Other ACTIVITY Fields Ends Here****************/

  useEffect(() => {
    if (activityID) {
      const url =
        constants.base_url +
        "/lab/activity/" +
        activityID +
        "?type=programming"
        ;
      const fetchData = async () => {
        try {
          const response = await httpService.get(url);
          setProgrammingActivityDetails(response.data?.program_data);
          setAccessControlsProgActivity(response.data?.access_control_vars);
          setActivityDescription(response.data?.program_data?.description);
          setActivityTitle(response.data?.program_data?.name);
          setLabTitle(response?.data?.program_data?.lab_name)
          setProvideAdditionalFiles(
            response.data?.program_data?.is_instructor_additonal_file_present
          );

          // Extract and set additional files if present
          const {
            c_instructor_additional_file,
            cpp_instructor_additional_file,
            simplecpp_instructor_additional_file,
          } = response.data.program_data;

          const cFiles = await extractAndSetFiles(
            c_instructor_additional_file,
            "C"
          );
          const cppFiles = await extractAndSetFiles(
            cpp_instructor_additional_file,
            "C++"
          );
          const simplecppFiles = await extractAndSetFiles(
            simplecpp_instructor_additional_file,
            "Simplecpp"
          );

          setInstructorAdditionalFiles({
            C: cFiles,
            "C++": cppFiles,
            Simplecpp: simplecppFiles,
          });

          const document = await downloadFile(
            response.data.program_data.document
          );
          setDocument(document);
          }  
        catch (error) {
          log.error("Error fetching activity:", error);
        }
      };

      fetchData();
    }
  }, [activityID, activityType]);

  useEffect(() => {
    const fetchLabData = async () => {
      if (labID) {
        var url = constants.base_url + "/lab/all/" + labID + `?courseId=${courseId}`;
        try {
          const response = await httpService.get(url);
          setLabTitle(response.data.lab.title);
          state.setDuration(response.data.lab.duration);
        } catch (error) {
          log.log(error);
        }
  
      }
    };
  
    fetchLabData();
  }, [labID]);

  const extractAndSetFiles = async (fileUrl, languageKey) => {
    if (!fileUrl) return [];

    try {
      const zipResponse = await httpService.get(fileUrl, {
        responseType: "arraybuffer",
      });
      const zip = new JSZip();
      const zipContent = await zip.loadAsync(zipResponse.data);
      const files = [];

      for (const fileName in zipContent.files) {
        const file = zipContent.files[fileName];
        if (!file.dir) {
          const fileData = await file.async("blob");
          files.push(new File([fileData], fileName));
        }
      }
      return files;
    } catch (error) {
      log.error(`Error extracting ${languageKey} files:`, error);
      return [];
    }
  };

  //Function to download a normal file and set it to the state
  const downloadFile = async (fileUrl) => {
    if (!fileUrl) return null;

    try {
      // Make a GET request to the fileUrl, expecting a blob response
      const fileResponse = await httpService.get(fileUrl, {
        responseType: "blob",
      });
      const url = fileResponse.config.url;
      const fileName = url.substring(url.lastIndexOf("/") + 1);
      // Create a new File object with the response data and the provided filename
      const file = new File([fileResponse.data], fileName);
      return file;
    } catch (error) {
      log.error(`Error downloading file`, error);
      return null;
    }
  };

  return (
    <div style={{minWidth:"100%"}}>
      <Breadcrumb>
        <Breadcrumb.Item href="#">
          <Link to={`/courseware/course/${courseId}/content/labs`}>Labs</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href="#">
          <Link to={`/courseware/course/${courseId}/content/labs/${labID}/`}>
            {labTitle}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
        <Link to={`/courseware/course/${courseId}/content/labs/${labID}/programming/${activityID}`}>
          {activity_title}
          </Link>
          </Breadcrumb.Item>
      </Breadcrumb>
        <>
          <ProgrammingActivity
            programId={activityID}
            courseId={courseId}
            labID={labID}
            activity_title={activity_title}
            activity_description={activity_description}
            AccessControlsProgActivity={AccessControlsProgActivity}
            ProgrammingActivityDetails={ProgrammingActivityDetails}
            setAccessControlsProgActivity={setAccessControlsProgActivity}
            provideAdditionalFiles={provideAdditionalFiles}
            instructorAdditionalFiles={instructorAdditionalFiles}
            document={document}
            studentData={studentData}
            isExam={isExam}
          />
        </>
    </div>
  );
}
export default ActivityContainer;
